import { searchUrl } from "findem-helpers";

/**
 * Generates a daily version number for cache busting
 * Changes once per day
 * https://findemjira.atlassian.net/browse/SUP-1000
 */
function getDailyVersion(): string {
  const msPerDay = 24 * 60 * 60 * 1000;
  return String(Math.floor(Date.now() / msPerDay));
}

export function getLinkedInId(link: string): string {
  let returnVal = "";
  if (link && link.length > 0) {
    const linkComponents = link?.split("/") || [];
    if (linkComponents[linkComponents.length - 1] !== "") {
      returnVal = linkComponents[linkComponents.length - 1];
    }
  }
  return returnVal;
}

export function getActiveLinkedInExtRef({ extRefs }: { extRefs?: any[] }): any | undefined {
  if (!Array.isArray(extRefs)) {
    return undefined;
  }

  return extRefs.find((ref: any) => ref?.source?.toLowerCase() === "linkedin" && ref?.is_dead !== true);
}

export function getProfileIconLink(profile?: any): string | undefined {
  if (!profile) return undefined;

  const version = getDailyVersion();

  // Construct S3 URL from LinkedIn ID
  const linkedInUrl = profile?.candidate?.linkedin;
  if (linkedInUrl) {
    const linkId = getLinkedInId(linkedInUrl);
    if (linkId) {
      return `https://fm-profile-imgs.s3.us-east-2.amazonaws.com/${linkId}.jpg?v=${version}`;
    }
  }

  // Check ext_refs for LinkedIn source_ref (direct image URL)
  const linkedInRef = getActiveLinkedInExtRef({ extRefs: profile?.ext_refs });
  if (linkedInRef?.source_ref) {
    return `https://fm-profile-imgs.s3.us-east-2.amazonaws.com/${getLinkedInId(linkedInRef.source_ref)}.jpg?v=${version}`;
  }

  // Fallback to API endpoint
  if (profile?.ref) {
    return `${searchUrl}/pub/api/profile_image?prid=${profile.ref}&v=${version}`;
  }

  return undefined;
}
